// Monthly payment
import { MATURITY_YEARS } from '../../constants';
import { getNumberOfPayments } from './getNumberOfPayments';

export function calculateMonthlyInstallment(amount: number, interestRate: number, maturity = MATURITY_YEARS): number {
  const numberOfPayments = getNumberOfPayments(maturity);
  return (amount * interestRate) / (1 - Math.pow(1 + interestRate, -numberOfPayments));
}
